/** @typedef {import('./store').RootState}   RootState */
/** @typedef {import('./store').AppDispatch} AppDispatch */
import { useDispatch as useDispatchRedux, useSelector as useSelectorRedux } from 'react-redux';

/**
 * A typed version of `useDispatch`.
 * @returns {AppDispatch}
 */
export const useDispatch = () => useDispatchRedux();

/**
 * A typed version of `useSelector`.
 * @template Selected
 * @param {(state: RootState) => Selected} selector
 * @param {import('react-redux').EqualityFn<Selected>} [equalityFn]
 * @returns {Selected}
 */
export const useSelector = (selector, equalityFn) => useSelectorRedux(selector, equalityFn);
